/**
 * Created by neo on 20.01.21.
 */

export type MediaAudioTrack = {
  title: string;
  language: string;
  url: string;
  index: number;
  mimeType: string;
  filename?: string;
};

/** @deprecated Use raw object instead */
export function createMediaAudioTrack(json?: Partial<MediaAudioTrack>): MediaAudioTrack {
  return {
    title: json?.title ?? '',
    language: json?.language ?? '',
    url: json?.url ?? '',
    filename: json?.filename,
    index: json?.index ?? 0,
    mimeType: json?.mimeType ?? '',
  };
}
